import type { Class } from "types/Class";

let allClassesCache: Class[] | null = null;
let allClassesPromise: Promise<Class[]> | null = null;

const yearClassesCache = new Map<number, Class[]>();
const yearClassesPromises = new Map<number, Promise<Class[]>>();

const dedupeClasses = (classes: Class[]): Class[] => {
  const seen = new Set<number>();

  return classes.filter((classItem) => {
    if (seen.has(classItem.id)) return false;

    seen.add(classItem.id);
    return true;
  });
};

const getAllClassesCache = (): Class[] | null =>
  allClassesCache ? [...allClassesCache] : null;

const setAllClassesCache = (classes: Class[]) => {
  const dedupedClasses = dedupeClasses(classes);

  allClassesCache = dedupedClasses;
  yearClassesCache.clear();

  for (const classItem of dedupedClasses) {
    const currentYearClasses = yearClassesCache.get(classItem.year) || [];
    yearClassesCache.set(classItem.year, [...currentYearClasses, classItem]);
  }
};

const getAllClassesPromise = () => allClassesPromise;

const setAllClassesPromise = (promise: Promise<Class[]> | null) => {
  allClassesPromise = promise;
};

const getYearClassesCache = (year: number): Class[] | null => {
  if (yearClassesCache.has(year)) {
    return [...(yearClassesCache.get(year) || [])];
  }

  if (!allClassesCache) return null;

  const classesOfYear = allClassesCache.filter(
    (classItem) => classItem.year === year,
  );
  yearClassesCache.set(year, classesOfYear);
  return [...classesOfYear];
};

const setYearClassesCache = (year: number, classes: Class[]) => {
  yearClassesCache.set(year, dedupeClasses(classes));
};

const getYearClassesPromise = (year: number) =>
  yearClassesPromises.get(year) || null;

const setYearClassesPromise = (
  year: number,
  promise: Promise<Class[]> | null,
) => {
  if (!promise) {
    yearClassesPromises.delete(year);
    return;
  }

  yearClassesPromises.set(year, promise);
};

const clearClassOptionCache = () => {
  allClassesCache = null;
  allClassesPromise = null;
  yearClassesCache.clear();
  yearClassesPromises.clear();
};

export {
  getAllClassesCache,
  setAllClassesCache,
  getAllClassesPromise,
  setAllClassesPromise,
  getYearClassesCache,
  setYearClassesCache,
  getYearClassesPromise,
  setYearClassesPromise,
  clearClassOptionCache,
};
